<header-style-default></header-style-default>
<main>
    <router-outlet></router-outlet>
</main>
<app-footer-style-default></app-footer-style-default>